export default "__VITE_ASSET__e11122a7__"